import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from '../hooks/use-user-role';

export type PlatformAdminAndOrganisationAdminRouteWrapperProps = {
  children: ReactNode;
  fallback?: string;
};

/**
 * A wrapper to be used around routes which are only accessibly for Platform Admin and Organisation Admin users.
 * Other users will be redirected back to the fallback url if they access this url
 */
export const PlatformAdminAndOrganisationAdminRouteWrapper: FC<
  PlatformAdminAndOrganisationAdminRouteWrapperProps
> = ({ children, fallback = '/' }) => {
  const { isPlatformAdmin, isOrgAdmin } = useUserRole();

  return isPlatformAdmin || isOrgAdmin ? children : <Navigate to={fallback} />;
};
